import { splitTime } from '@devd-client/devd/components';

export const tabs: Record<string, number> = {
  teamStats: 0,
  teamMetrics: 1,
  teamGoals: 2,
  contributors: 3,
  repositories: 4,
  sprint: 5,
  team: 6,
  workingAgreement: 7,
  inProgress: 8,
};

export const employeeTabs: Record<string, number> = {
  teamStats: 0,
  teamMetrics: 1,
  repositories: 2,
  sprint: 3,
  team: 4,
  workingAgreement: 5,
  inProgress: 6,
};

export const tabList: string[] = [
  'Team Statistics',
  'Team Metrics',
  'Team Goals',
  'Contributors Velocity',
  'Repositories Velocity',
  'Sprint Velocity',
  'Team Collaboration',
  'Working Agreement',
  'InProgress Work Item',
];

export const employeeTabList: string[] = [
  'Team Statistics',
  'Team Metrics',
  'Repositories Velocity',
  'Sprint Velocity',
  'Team Collaboration',
  'Working Agreement',
  'InProgress Work Item',
];

export const convertToTimeFormat = (time: number) =>
  time === 0 || time === null ? '0h' : splitTime(time);

export const getTabList = (role: string): string[] => {
  if (role === 'EMPLOYEE') {
    return employeeTabList;
  } else {
    return tabList;
  }
};

export const getTabs = (role: string): Record<string, number> => {
  if (role === 'EMPLOYEE') {
    return employeeTabs;
  } else {
    return tabs;
  }
};

export const defaultMetrics = ['PR_CYCLE_TIME', 'TASK_CLOSE', 'PR_MERGE'];

export const formatLabel = (label: string) => {
  return label
    ?.replace(/([A-Z])/g, ' $1')
    ?.replace(/^./, (str: string) => str.toUpperCase())
    ?.replace('Pr', 'PR');
};
